import { useCallback, useContext, useEffect } from 'react';
import { useQueryClient } from '@zg-rentals/react-query5';
import { Box, Heading, Paragraph } from '@zillow/constellation-10';
import { submitIdentityAnswersMutationKey } from '../6KiqQuestions/KiqQuestionsStep';
import { useIdVerificationCallbacks, useTermSet } from '../../../IdvContext';
import usePerformIdentityCheck from '../../../hooks/usePerformIdentityCheck';
import { TermSet } from '../../../../../models';
import { LANDLORD_CLICKSTREAM_EVENTS } from '../../../clickstream/events';
import { WizardContext } from '../../../wizard/WizardContext';

export default function KiqOnboardingStep() {
  const { setOnNext } = useContext(WizardContext);
  const { trackEvent } = useIdVerificationCallbacks();
  const termSet = useTermSet();
  const queryClient = useQueryClient();
  const mutations = queryClient.getMutationCache().getAll();
  const hasSubmittedIdentityAnswers = mutations.some(
    (mutation) => JSON.stringify(mutation?.options?.mutationKey) === JSON.stringify(submitIdentityAnswersMutationKey),
  );
  const performIdentityCheck = usePerformIdentityCheck();

  const getKiqQuestions = useCallback(() => {
    if (termSet === TermSet.LandlordScreening) {
      trackEvent(LANDLORD_CLICKSTREAM_EVENTS.clickNextOntoKBA);
    }

    performIdentityCheck();
  }, [termSet, trackEvent, performIdentityCheck]);

  useEffect(() => {
    if (hasSubmittedIdentityAnswers) {
      setOnNext(() => getKiqQuestions);
    }
    return () => setOnNext(null);
  }, [hasSubmittedIdentityAnswers, setOnNext, getKiqQuestions]);

  return (
    <Box css={{ display: 'flex', flexDirection: 'column', gap: 'default' }}>
      <Heading level={2} textStyle="heading-sm">
        Answer identity verification questions
      </Heading>
      <Paragraph>On the next screen, you’ll be asked a few questions to complete the verification process.</Paragraph>
      <Paragraph>
        After you choose <strong>Next</strong>, you’ll have <strong>5 minutes</strong> to complete this step.
      </Paragraph>
      <Paragraph>Don’t refresh the page while answering questions.</Paragraph>
    </Box>
  );
}
